import { surfaceClassName } from '../../utils/dashboardStyles';

function Panel({ title, description, children }) {
  return (
    <article className={`${surfaceClassName} p-5 sm:p-6`}>
      {title ? (
        <div className="mb-5">
          <h3 className="m-0 text-[1.05rem] font-semibold tracking-[-0.03em] text-[var(--theme-text)] sm:text-[1.15rem] lg:text-[1.2rem]">
            {title}
          </h3>
          {description ? (
            <p className="m-0 mt-2 text-[0.96rem] leading-6 text-[var(--theme-text-muted)]">{description}</p>
          ) : null}
        </div>
      ) : null}
      {children}
    </article>
  );
}

export default Panel;
